module.exports = __webpack_public_path__ + "static/Celia_Seba-e834c60a84d209d8a0eabf078d23c1fd.webp";